import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';
import { CALL_REFS, ERROR_CODES } from '@/consts';

export default {
  async getClientByPhoneNumber(phoneNumber) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/clients/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          phoneNumber
        }
      }, false);

      const { items } = processSuccessResponse(res);

      return items[0];
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addOrderCall(callId, orderId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/order-calls/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data: { orderId, callId } }, false);
      processSuccessResponse(res);
      return true;
    } catch(e) {
      return false;
    }
  },

  processCallRef(callId, ref) {
    if (ref?.type) {
      const { type, id } = ref;

      switch(type) {
        case CALL_REFS.ORDER:
          this.addOrderCall(callId, id);
          break;

        default:
          break;
      }
    }
  },

  async checkCallLog(remote) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/call-logs/',
      method: HttpMethod.GET
    };

    const params = {
      remote,
      latest: true,
      page: 1,
      pageSize: 20
    };

    try {
      const res = await processRequest(ep, { params }, false);
      const { items } = processSuccessResponse(res);
      return items;
    } catch(e) {
      if (e.response?.status !== 404) {
        processErrorResponse(e.response);
      }
      return false;
    }
  },

  async logCall({ id, cseq, direction, status, extension, remote, duration = 0, ref }) {
    const callLogs = !id && remote ? await this.checkCallLog(remote) : [];

    const exists = callLogs.length > 0 || !!id;

    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      method: exists ? HttpMethod.PATCH : HttpMethod.POST
    };

    if (exists) {
      ep.url = `/v1/call-logs/${id ? `${id}/` : `${callLogs[0].id}/`}`;
    } else {
      ep.url = '/v1/call-logs/';
    }

    let data = {
      status,
      extension,
      duration
    };

    if (!exists) {
      data = {
        ...data,
        cseq,
        direction,
        remote
      };
    }

    try {
      const res = await processRequest(ep, { data }, false);
      const call = processSuccessResponse(res);

      if (!exists) {
        this.processCallRef(call.id, ref);
      }

      return call.id;
    } catch(e) {
      const { code } = e.response.data.error;

      if (code === ERROR_CODES.CALL_LOG_ALREADY_EXISTS) {
        const logs = await this.checkCallLog(remote);
        return logs[0].id;
      }
      return false;
    }
  },

  async getCallLogs() {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/call-logs/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          page: 1,
          pageSize: 100
        }
      }, false);
      const { items } = processSuccessResponse(res);
      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
